/* eslint-disable @typescript-eslint/no-explicit-any, camelcase */

/**
 * This file is autogenerated, please don't edit it manually.
 * Use this command to regenerate it if you modified Epic experiments:
 * yarn epic:types
 */

/**
 * Epic experiments namespaces with their possible keys.
 * Autogenerated from static/bundles/epic/data/defaults/
 */
import client from 'bundles/epic/client';
import GrowthDiscovery from 'bundles/epic/data/defaults/GrowthDiscovery.json';
import type { Tags } from 'bundles/epic/lib/EpicTypes';

type Namespace = {
  showEvolveCollection: boolean;
  showEvolveCollectionBrowse: boolean;
  showUpdatedNoResultsPage: boolean;
  showBrowseInSerp: boolean;
  productCardLeftVsRight: 'control' | 'B' | 'C';
  coachInSearch: 'control' | 'B';
  cmsProxyBffEnabled: boolean;
  enableAiReviews: boolean;
  enableBrowseSkillPages: boolean;
  showSearchBannerOnLOHP: boolean;
  enableXDPRedesignPhase1: boolean;
  enableXDPRedesignKIM: boolean;
  enableXDPRedesignHero: boolean;
  enableXDPRedesignDescriptionRework: boolean;
  disableXDPThinBanner: boolean;
  enableEnterpriseHomeProfileBar: boolean;
  enableConsumerLearningPreview: boolean;
  enableTargetingStrategyInputForCampaign: boolean;
  removeC4bCtaFromLohpHero: boolean;
  aiRecapOnHome: boolean;
  isDefaultFAQsForFreemiumEnabled: boolean;
  showLearnerObjectPathways: boolean;
  enableXDPRedesignPhase2: 'control' | 'B' | 'C';
  showRecommendationsOnXdp: 'control' | 'B' | 'C';
  coachCareerFitAssistantOnXdp: 'control' | 'B' | 'C';
  shouldShowAiAssistanceOnLOHPForSignupAbandonment: boolean;
  shouldShowAiAssistanceOnLOHPForProductDecision: boolean;
  showFindBetterFit: boolean;
  promoBarBannerColourExperiment:
    | 'control'
    | 'experimental-color-blue-abstract-gradient'
    | 'experimental-color-pink-abstract-gradient'
    | 'primary-blue-xxstrong'
    | 'experimental-color-expressive-yellow';
  enablePathwaysForAll: boolean;
  enableCardTakeoverExperiment: boolean;
  enableConsumerPageSpecificQuery: boolean;
  enableEnterprisePageSpecificQuery: boolean;
};

const NAMESPACE = 'GrowthDiscovery';

// Adding safe optional chaining to avoid massive changes in unit tests.
client.addDefaults?.([GrowthDiscovery as $TSFixMe]);

const GrowthDiscoveryEpicClient = {
  get<K extends keyof Namespace>(key: K, tags?: Tags): Namespace[K] {
    return client.get(NAMESPACE, key, tags);
  },

  preview<K extends keyof Namespace>(key: K, tags?: Tags, defaults?: Namespace): Namespace[K] {
    return client.preview(NAMESPACE, key, tags);
  },
};

export default GrowthDiscoveryEpicClient;
